const rawLang = (document.documentElement.lang || 'ru').toLowerCase();
const currentLang = rawLang.startsWith('ro') ? 'ro' : 'ru';
const urls = { ro: 'cart', ru: 'cart' };

function getProductData(productId) {
    return fetch(`/product/find_one/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lang: currentLang, id: productId })
    })
        .then(response => {
            if (!response.ok) throw new Error(`${response.status}`);
            return response.json();
        })
        .then(product => {
            if (!product || !product.id) throw new Error('нет товара с таким ID');
            const mappedProduct = {
                ecom_id: product.id,
                ecom_name: product.name_ru || product.name_ro || `Product ${productId}`,
                ecom_category: product.category || 'Default Category',
                ecom_brand: product.brand || 'Default Brand',
                ecom_price: product.discounted_price || product.price || 0,
                ecom_discount: product.reduction || 0,
                ecom_list_id: "default_list",
                ecom_list_name: "Default List",
                ecom_index: 1
            };
            return mappedProduct;
        })
        .catch(() => null);
}

function rrAddToBasket(productId, quantity = 1) {
    return new Promise((resolve) => {
        $.post(`/${currentLang}/${urls[currentLang]}/add/`, { id: productId, qty: quantity }, function(result) {
            try {
                const data = (typeof result === 'string') ? JSON.parse(result) : result;

                if (data && data.ecommerce_item) {
                    AddToCart(data.ecommerce_item);

                    let listData = JSON.parse(getCookie('product_list_data') || '[]');
                    let found = false;
                    for (let dataItem of listData) {
                        if (dataItem.product_id === productId) { found = true; break; }
                    }
                    if (!found) {
                        listData.push({
                            product_id: productId,
                            list_id: data.ecommerce_item.item_list_id || "default_list",
                            list_name: data.ecommerce_item.item_list_name || "Default List"
                        });
                        setCookie('product_list_data', JSON.stringify(listData), 7);

                        $(".cart_num").attr("data-count", data.qty).css('z-index', 99);
                        $(".cart_num").addClass('blink');
                        setTimeout(() => $(".cart_num").removeClass('blink'), 500);
                    }

                    // Toast is defined in app/js/noOptimize.js
                    if (typeof globalThis.showAddedToCartToast === 'function') {
                        globalThis.showAddedToCartToast();
                    }
                    resolve(true);
                } else {
                    console.error(data);
                    resolve(false);
                }
            } catch (error) {
                console.error(error);
                resolve(false);
            }
        }).fail(function(xhr, status, error) {
            console.error({ status, error, xhr });
            resolve(false);
        });
    });
}

function removeFromBasket(productId, quantity = 1) {
    return new Promise((resolve) => {
        getProductData(productId).then(fallbackProduct => {
            if (!fallbackProduct) { resolve(false); return; }

            $.post(`/${currentLang}/${urls[currentLang]}/delete/`, { id: productId, qty: quantity }, function (result) {
                let data;
                try {
                    data = (typeof result === 'string') ? JSON.parse(result) : result;
                } catch (e) {
                    resolve(false);
                    return;
                }

                const itemFromServer = data.ecommerce_item || null;

                const newItemQty = Number(
                    (itemFromServer && itemFromServer.quantity) ??
                    data.qty_by_id ??
                    data.qty_in_cart_by_id ??
                    0
                );

                const totalCartQty = Number(data.qty ?? data.total_qty ?? data.cart_qty ?? 0);

                $(".cart_num").attr("data-count", totalCartQty).css('z-index', 99).addClass('blink');
                setTimeout(() => $(".cart_num").removeClass('blink'), 500);

                const fallbackItem = {
                    item_id: String(fallbackProduct.ecom_id),
                    item_name: fallbackProduct.ecom_name,
                    item_brand: fallbackProduct.ecom_brand,
                    item_category: fallbackProduct.ecom_category,
                    price: fallbackProduct.ecom_price,
                    quantity: 1,
                    item_list_id: fallbackProduct.ecom_list_id,
                    item_list_name: fallbackProduct.ecom_list_name,
                    index: fallbackProduct.ecom_index,
                };

                RemoveFromCart(itemFromServer || fallbackItem);

                if (newItemQty <= 0) {
                    let listData = JSON.parse(getCookie('product_list_data') || '[]');
                    listData = listData.filter(x => String(x.product_id) !== String(productId));
                    setCookie('product_list_data', JSON.stringify(listData), 7);
                }

                resolve(true);
            }).fail(function (xhr, status, error) {
                console.error({ status, error, xhr });
                resolve(false);
            });
        }).catch(() => resolve(false));
    });
}

function rrAddToCompare(productId) {
    return getProductData(productId).then(product => {
        if (!product) { console.error("rrAddToCompare: No product", productId); return false; }

        try {
            $.post(`/${currentLang}/ajax/add_to_compare/`, { id: productId }, function(result) {
                try {
                    const data = (typeof result === 'string') ? JSON.parse(result) : result;
                    if (data && data.action === 'add') {
                        AddToComparison(product);

                        let listData = JSON.parse(getCookie('product_list_data') || '[]');
                        if (!listData.some(d => d.product_id === productId)) {
                            listData.push({ product_id: productId, list_id: product.ecom_list_id, list_name: product.ecom_list_name });
                            setCookie('product_list_data', JSON.stringify(listData), 7);
                        }

                        const cnt = Number.isFinite(+data.count) ? +data.count : 0;
                        $('.compare_count p').attr('data-count', cnt).css('z-index', 99);
                    } else {
                        console.error('rrAddToCompare: bad action', data);
                    }
                } catch (error) {
                    console.error(error);
                }
            }).fail(function(xhr, status, error) {
                console.error({ status, error, xhr });
            });

            return true;
        } catch (error) {
            console.error("rrAddToCompare error", error);
            return false;
        }
    });
}

function rrRemoveFromCompare(productId) {
    return getProductData(productId).then(product => {
        if (!product) return false;

        try {
            $.post(`/${currentLang}/ajax/add_to_compare/`, { id: productId, action: 'remove' }, function(result) {
                try {
                    const data = (typeof result === 'string') ? JSON.parse(result) : result;

                    if (data && data.action === 'remove') {
                        const item = datasetNormalizer(product);
                        delete item.quantity;

                        sendToDataLayer({
                            event: 'remove_from_compare',
                            ecommerce: { currency: 'MDL', value: item.price, items: [item] }
                        });

                        let currentCount = parseInt($('.compare_count p').attr('data-count') || 0);
                        if (currentCount > 0) {
                            $('.compare_count p').attr('data-count', currentCount - 1).css('z-index', 99);
                        }
                    } else {
                        console.error("rrRemoveFromCompare: Operation failed", data);
                    }
                } catch (error) {
                    console.error(error);
                }
            }).fail(function(xhr, status, error) {
                console.error({ status, error, xhr });
            });

            return true; // успех инициации запроса
        } catch (error) {
            console.error(error);
            return false;
        }
    });
}

function rrAddToFavorite(productId) {
    return getProductData(productId).then(product => {
        if (!product) return false;

        try {
            $.post(`/${currentLang}/ajax/add_to_favorite/`, { id: productId }, function(result) {
                try {
                    const data = (typeof result === 'string') ? JSON.parse(result) : result;
                    if (data && data.action === 'add') {
                        AddToWishlist(product);

                        let listData = JSON.parse(getCookie('product_list_data') || '[]');
                        if (!listData.some(d => d.product_id === productId)) {
                            listData.push({ product_id: productId, list_id: product.ecom_list_id, list_name: product.ecom_list_name });
                            setCookie('product_list_data', JSON.stringify(listData), 7);
                        }

                        const cnt = Number.isFinite(+data.count) ? +data.count : 0;
                        $('.favorite_count p').attr('data-count', cnt).css('z-index', 99);
                    }
                } catch (error) {
                    console.error(error);
                }
            }).fail(function(xhr, status, error) {
                console.error({ status, error, xhr });
            });

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    });
}

function rrRemoveFromFavorite(productId) {
    return getProductData(productId).then(product => {
        if (!product) return false;

        try {
            $.post(`/${currentLang}/ajax/add_to_favorite/`, { id: productId, action: 'remove' }, function(result) {
                try {
                    const data = (typeof result === 'string') ? JSON.parse(result) : result;
                    if (data && data.action === 'remove') {
                        const item = datasetNormalizer(product);
                        delete item.quantity;
                        sendToDataLayer({
                            event: 'remove_from_wishlist',
                            ecommerce: { currency: 'MDL', value: item.price, items: [item] }
                        });

                        let currentCount = parseInt($('.favorite_count p').attr('data-count') || 0);
                        if (currentCount > 0) {
                            $('.favorite_count p').attr('data-count', currentCount - 1).css('з-index', 99);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }).fail(function(xhr, status, error) {
                console.error({ status, error, xhr });
            });

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    });
}

(function () {
    const api = (globalThis.rrApi = globalThis.rrApi || {});

    api.removeFromBasket   = removeFromBasket;
    api.removeFromCompare  = rrRemoveFromCompare;
    api.removeFromFavorite = rrRemoveFromFavorite;

    globalThis.rrAddToBasket   = globalThis.rrAddToBasket   || rrAddToBasket;
    globalThis.rrAddToCompare  = globalThis.rrAddToCompare  || rrAddToCompare;
    globalThis.rrAddToFavorite = globalThis.rrAddToFavorite || rrAddToFavorite;
})();
